"use client";

// imports
import { useAtom } from 'jotai';

// lib files
import {
  locateAtom,
} from '@/lib/atoms/location-verification';
import { useHasMounted } from '@/lib/hooks';

// styles
import styles from './LocateUnauthorized.module.scss';

const LocateUnauthorized = (props: { depStationName?: string }) => {
  const { depStationName } = props;
  const hasMounted = useHasMounted();
  const [locateState, _] = useAtom(locateAtom);

  const { verifiedStationShortCommonName: shortCommonName } = locateState;

  const stationName = depStationName || shortCommonName;

  const stationString = stationName ? `the ${stationName}` : 'your PBS Station’s';

  if(!hasMounted) return null;
  return (
    <div className={styles.locate_unauthorized}>
      <h1 className={styles.locate_unauthorized__headline}>It looks like your devices may be outside of {stationString} broadcast coverage area.</h1>
      <p className={styles.locate_unauthorized__text}>
      Please return to your device for more options or to stream your favorite PBS shows on-demand.
      </p>
      <p className={styles.locate_unauthorized__text}>For more information visit <a href="https://www.pbs.org/livestreamhelp/" target="_blank">www.pbs.org/livestreamhelp</a></p>
    </div>
  );
};

export default LocateUnauthorized;
